<template>
  <section id="about" class="about">
    <div class="shell about-grid">
      <figure v-reveal class="about-photo">
        <div class="about-photo-frame">
          <img
            src="/photos/adrian.webp"
            srcset="/photos/adrian-400.webp 400w, /photos/adrian.webp 900w"
            sizes="(max-width: 900px) 88px, 300px"
            alt="Adrian West, founder and lead engineer of West Dev Solutions"
            width="900"
            height="1125"
            loading="lazy"
            decoding="async"
          />
        </div>
        <figcaption class="about-caption">
          <strong>Adrian West</strong>
          <span>Founder and lead engineer</span>
        </figcaption>
      </figure>
      <div v-reveal class="about-copy">
        <h2>Who you’ll work with</h2>
        <p class="about-lead">
          I’m Adrian, a backend engineer with more than six years of experience
          building production systems, much of it in fintech: payment
          processing, financial report automation and data pipelines.
        </p>
        <p>
          West Dev Solutions brings that same engineering to small and growing
          businesses. You speak directly with the person doing the work, and I
          take on a small number of projects at a time so each one gets proper
          attention.
        </p>
        <dl class="stack">
          <div v-for="group in stack" :key="group.name">
            <dt>{{ group.name }}</dt>
            <dd>{{ group.items }}</dd>
          </div>
        </dl>
        <a href="#contact" class="text-link">Tell me what you have in mind</a>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "AboutSection",
  data: () => ({
    stack: [
      { name: "Languages", items: "C#, .NET, Node.js, PHP, SQL" },
      { name: "Front end and mobile", items: "Vue.js, React, Laravel, Flutter" },
      {
        name: "Cloud",
        items: "Azure Functions, App Services and Blob Storage, AWS, Linux, CI/CD",
      },
      {
        name: "Data and integration",
        items: "SQL Server, MySQL, ETL pipelines, REST, SOAP, SFTP",
      },
    ],
  }),
};
</script>
